export var ValidityState;
(function (ValidityState) {
    ValidityState["Indeterminate"] = "indeterminate";
    ValidityState["FrontendValid"] = "frontendValid";
    ValidityState["BackendValid"] = "backendValid";
    ValidityState["Invalid"] = "invalid";
    ValidityState["Info"] = "info";
})(ValidityState || (ValidityState = {}));
export function getValidityState(reason) {
    if (!reason) {
        return { valid: ValidityState.FrontendValid };
    }
    return {
        valid: ValidityState.Invalid,
        reason
    };
}
export const getAsyncValidator = (validator) => (value) => new Promise((resolve) => resolve(validator(value)));
